import Clicker from './utility/Clicker';

function App() {
  return (
    <div className="bg-red-pantone min-h-screen flex flex-col justify-end">
      <Clicker />
    </div>
  );
}

export default App;
